import { parse, parseDocument, stringify, visit } from 'yaml'
export function parseConfigDocument(source, format) {
  const document = format === 'json' ? JSON.parse(source) : parse(source)
  if (!document || typeof document !== 'object' || Array.isArray(document)) throw new Error('配置源码必须是键值对象')
  return document
}
export function configAtPath(document, path) {
  if (!Array.isArray(path) || path.length === 0) throw new Error('Host 未提供配置路径，请刷新或打开完整源码')
  return path.reduce((value, key) => value && typeof value === 'object' && Object.hasOwn(value, key) ? value[key] : undefined, document)
}
export function replaceConfigAtPath(document, path, value) {
  if (!Array.isArray(path) || path.length === 0 || path.some(key => typeof key !== 'string' || ['__proto__', 'prototype', 'constructor'].includes(key))) throw new Error('Host 配置路径无效，请刷新或打开完整源码')
  const result = structuredClone(document)
  let target = result
  path.forEach((key, index) => {
    if (index === path.length - 1) Object.defineProperty(target, key, { value: structuredClone(value), writable: true, configurable: true, enumerable: true })
    else {
      const child = Object.hasOwn(target, key) ? target[key] : undefined
      if (child !== undefined && (!child || typeof child !== 'object' || Array.isArray(child))) throw new Error('配置父节点不是对象，请打开完整源码确认结构')
      Object.defineProperty(target, key, { value: { ...(child ?? {}) }, writable: true, configurable: true, enumerable: true })
      target = target[key]
    }
  })
  return result
}
export function configSourceForPlugin(source, format, path, value) {
  const next = replaceConfigAtPath(parseConfigDocument(source, format), path, value)
  if (format === 'json') return `${JSON.stringify(next, null, 2)}\n`
  const document = parseDocument(source)
  let hasAlias = false
  visit(document, { Alias() { hasAlias = true } })
  // Alias-bearing documents must be detached before mutation to avoid changing another plugin.
  if (hasAlias) return stringify(next, { lineWidth: 0 })
  document.setIn(path, value)
  return document.toString({ lineWidth: 0 })
}
